// removed by extract-text-webpack-plugin
module.exports = {"trademark_div":"wmf-2pe7NNjF","trademark_div_bottom":"wmf-3d4Gj9T3","publi_span":"wmf-EAfFsd5I"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/brandqualification/brand-qualification-edit.module.less
// module id = 3852
// module chunks = 0